import React from 'react';
import PropTypes from 'prop-types';

export const AvatarImage = ({
  avatarImageUrl,
  changeProfilePictureText,
  onAvatarSelectLinkClick,
  titleText,
  isViewOnly = false,
}) => (
  <div className="picture-and-link">
    <img
      className="center-block img-circle"
      id="profile-picture"
      src={avatarImageUrl}
      title={titleText}
      alt={titleText}
    />
    <p
      id="change-pick-link"
      className="text-center" style={{marginTop: '10px'}}>
      {isViewOnly &&
        <span
          className="view-only-text"
          title={changeProfilePictureText}>
          {changeProfilePictureText}
        </span>}
      {!isViewOnly &&
        //{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          href="#"
          onClick={onAvatarSelectLinkClick}
          tabIndex="0"
          title={changeProfilePictureText}
          aria-label={changeProfilePictureText}
        >{changeProfilePictureText}</a>}
    </p>
  </div>
);

AvatarImage.propTypes = {
  avatarImageUrl: PropTypes.string.isRequired,
  changeProfilePictureText: PropTypes.string.isRequired,
  onAvatarSelectLinkClick: PropTypes.func.isRequired,
  titleText: PropTypes.string.isRequired,
  isViewOnly: PropTypes.bool,
};

export default AvatarImage;
